.root {
  position: relative;

  .label {
    position: relative;
    padding: 16px 24px 16px 16px;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #dfe1e4;
    cursor: pointer;
    user-select: none;

    &::after {
      position: absolute;
      right: 16px;
      content: '\2039';
      transform: rotate(-90deg);
      font-size: 32px;
      line-height: 20px;
    }

    &:hover {
      border-color: #3597fc;
    }

    &.open {
      border-color: #1f5be4;
    }
  }

  .options {
    border: 1px solid #dfe1e4;
    position: absolute;
    top: calc(100% + 4px);
    border-radius: 4px;
    z-index: 2;
    background-color: white;
    padding: 4px;
    width: 100%;
  }

  .option {
    padding: 4px;
    border-radius: 2px;
    cursor: pointer;

    &:hover {
      background-color: #dde5fd;
    }
  }
}
